const state = {};

const getters = {
  getRegion(state) {
    const storedRegion = localStorage.getItem('region');
    if (['AU', 'NZ', 'HK'].includes(storedRegion)) return storedRegion;
    return 'AU';
  }
};

const actions = {
  setRegion: ({ commit }, region) => {
    //store this in the localstoreage
    if (['AU', 'NZ', 'HK'].includes(region)) {
      localStorage.setItem('region', region);
      commit("setRegion", region);
    }
  },
};

const mutations = {
  setRegion: (state, region) => {
    location.reload();
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/region.js